<template>
	<v-app>

		<LoadingComponent :isLoading="$store.getters.loadingModal"/>
		<!--		<LoginModal/>-->

		<v-app-bar app elevation="11"
				   style="background: #11254d;background: linear-gradient(90deg,rgba(17, 37, 77, 1) 0%, rgba(17, 113, 112, 1) 50%, rgba(21, 168, 147, 1) 100%);">

			<v-img :src="require('./assets/Eudoxus_Logo_RGB_Gr.png')" style=" max-height:170px; max-width:200px" contain
				   alt="alt"></v-img>

			<v-spacer></v-spacer>
			<div class="banner-wrapper">
				<a href="https://www.espa.gr/en/Pages/default.aspx/" target="_blank">
					<v-img
							min-width="600px"
							:src="require('./assets/BANNER_MDT_ETPA4.png')"
					aspect-ratio="15"
					contain
					alt="Visit the ESPA website"
					class="banner-img"
					></v-img>
				</a>

				<p class="ma-0 pa-0 banner-text">
					<strong style="color: #DBDBDB">©2022 — Εύδοξος</strong>
				</p>
			</div>
			<v-spacer/>

			<v-btn text @click="toggleSearch"> {{simpleSearch?'Σύνθετη αναζήτηση':'Απλή αναζήτηση'}}</v-btn>
			<v-btn text @click="$store.commit('setInstructionsDialog', true)"> Οδηγίες</v-btn>
<!--			<v-menu offset-y attach="body">-->
<!--				<template v-slot:activator="{ attrs, on }">-->
<!--					<v-btn v-bind="attrs" v-on="on" text> Συμβατότητα</v-btn>-->
<!--				</template>-->

<!--				<div  role="region" aria-label="Browser Compatibility Info" class="compatibility-menu-content">-->
<!--					<p>-->
<!--						Η εφαρμογή είναι συμβατή με τους φυλλομετρητές Internet Explorer 7, Mozilla Firefox 3.0, Safari 4.0 ή νεώτερους.-->
<!--						Η χρήση της εφαρμογής ενδέχεται να είναι δυνατή και από άλλους φυλλομετρητές αλλά με ευθύνη του χρήστη.-->
<!--					</p>-->
<!--				</div>-->
<!--				<div role="menuitem" tabindex="-1" v-show="false">Placeholder</div>-->
<!--			</v-menu>-->

			<v-menu offset-y attach="body" bottom left>
				<template v-slot:activator="{ attrs, on }">
					<v-btn v-bind="attrs" v-on="on" text> Περί Χρήσης</v-btn>
				</template>

				<div class="compatibility-menu-content">
					<p>
						Η εφαρμογή προορίζεται κυρίως για τους διδάσκοντες και για τα διοικητικά στελέχη των Πανεπιστημίων και ΤΕΙ,
						προκειμένου να εντοπίζουν εύκολα και γρήγορα τα βιβλία και τους αντίστοιχους κωδικούς που μπορούν να
						επιλεγούν/δηλωθούν ως συγγράμματα για προπτυχιακά μαθήματα του κάθε Τμήματος. Η χρήση της αναζήτησης
						είναι ανοιχτή για κάθε ενδιαφερόμενο
					</p>
				</div>
				<div role="menuitem" tabindex="-1" v-show="false">Placeholder</div>
			</v-menu>

		</v-app-bar>


		<v-main class="mt-1" style="background: #11254d;background: linear-gradient(90deg,rgba(17, 37, 77, 1) 0%, rgba(17, 113, 112, 1) 50%, rgba(21, 168, 147, 1) 100%);">
			<router-view></router-view>
		</v-main>
<!--		<Footer/>-->
		<ErrorPopup/>
		<InstructionsDialog/>
	</v-app>
</template>

<script>

	import utils from './utilities';
	import requests from './requests';
	import store from "./store";

	import LoadingComponent from "./components/LoadingComponent";
	import LoginModal from "./components/LoginModal";
	import Footer from "./components/Footer";
	import ErrorPopup from "./components/ErrorPopup";
	import InstructionsDialog from "./components/InstructionsDialog";

	export default {
		name: 'App',
		components: {InstructionsDialog, ErrorPopup, LoginModal, LoadingComponent, Footer},
		data: () => ({
			drawer: true,
			navigationPath: '/',

		}),

		computed: {
			simpleSearch: {
				get() {
					return this.$store.getters.simpleSearch;
				},
				set(val) {
					this.$store.commit('setSimpleSearch', val);
				},
			}
		},

		methods: {

			toggleSearch() {
				this.$store.commit('setSimpleSearch', !this.simpleSearch);
				if(this.simpleSearch){
					this.$router.push({path: '/'});
				}else{
					this.$router.push({path: '/advanced'});
				}
			},


		},

		created() {
			// requests.put('rest/books/publishers', null, this.getPublishersCallBack);
			if (performance.navigation.type === 1 && this.$route.fullPath !== '/') {
				this.$router.push({path: '/'})
			}

			requests.get('rest/app/publishers', (resp) =>{
				this.$store.commit('setPublishersForSelector', resp);
				this.$store.commit('setLoadingPublishers', false);
			});

			// requests.get('rest/app/configuration', (resp) =>{
			// 	this.$store.commit('setFilesBaseUrl', resp.filesUrl);
			// 	this.$store.commit('setFilesThumbnailBaseUrl', resp.filesUrlThumb);
			// });

		},
		watch: {
			'$route'(to, from) {
				if (to.path !== this.navigationPath) {
					this.navigationPath = to.path;
				}
			}
		},

	}
</script>



<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	nav a {
		font-weight: bold;
		color: #2c3e50;
	}

	.v-btn {
		text-transform: none !important;
		font-weight: bold !important;
	}
	.v-tab {
		text-transform: none !important;
		font-weight: bold !important;
	}

	nav a.router-link-exact-active {
		color: #42b983;
	}

</style>

<style scoped>

	.compatibility-menu-content {
		background: white;
		color: #222;
		font-family: 'Roboto', sans-serif;
		font-size: 14px;
		line-height: 1.4;
		padding: 16px;
		max-width: 240px;
		min-width: 220px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
		z-index: 9999 !important;
		border: 3px solid transparent; /* Controls the thickness */
		border-image: linear-gradient(
				90deg,
				rgba(17, 37, 77, 1) 0%,
				rgba(17, 113, 112, 1) 50%,
				rgba(21, 168, 147, 1) 100%
		);
		border-image-slice: 1;
		border-radius: 0px;
		overflow: hidden;
	}
</style>
